import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError, retry } from 'rxjs/operators';
import { AuthmongoService } from './authmongo.service';
import { AllService } from './all.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User;
  loginUrl = environment.url_uu;

  constructor(private http: HttpClient, private authMongo: AuthmongoService,private allServ:AllService) {}

  /**
   * Returns the current user
   */
  public currentUser(): User {
    return getFirebaseBackend().getAuthenticatedUser();
  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string) {
    const cred = {
      username: email,
      password: password,
    };

    // return getFirebaseBackend().loginUser(email, password).then((response: any) => {
    //     const user = response;
    //     return user;
    // });

    return this.authMongo.login(cred).pipe(
      map((response) => {
        const user = response;
        return user;
      })
    ); //subscribe(response => {
  }

  //)

  // console.log(cred);
  // const t = this.loginUrl + 'auth/login';
  // return this.http.post(t, cred)
  // .pipe(
  //     map(response => {
  //         console.log(response);
  //         if(response['status'] !== 0) {
  //             sessionStorage.setItem('access', response['role']);
  //             sessionStorage.setItem('token', response['token']);
  //             sessionStorage.setItem('user', response['username']);
  //             sessionStorage.setItem('last_login', response['last_login']);
  //             sessionStorage.setItem('role_name', response['role_name']);
  //             sessionStorage.setItem('name', response['name']);
  //             sessionStorage.setItem('district', response['district']);
  //             return response['status'];
  //         } else {
  //                 return response['status'];
  //         }
  //     }, error => {
  //         return false;
  //     })
  // )

  // }

  /**
   * Performs the register
   * @param email email
   * @param password password
   */
  register(email: string, password: string) {
    return getFirebaseBackend()
      .registerUser(email, password)
      .then((response: any) => {
        const user = response;
        return user;
      });
  }

  /**
   * Reset password
   * @param email email
   */
  resetPassword(email: string) {
    return getFirebaseBackend()
      .forgetPassword(email)
      .then((response: any) => {
        const message = response.data;
        return message;
      });
  }

  /**
   * Logout the user
   */
  logout() {
    // logout the user
    // getFirebaseBackend().logout();
    this.authMongo.logout();
  }

  resetPassIn(data) {
    return this.http.post(this.loginUrl + 'auth/password_reset_in', data).pipe(
      map(
        (response) => {
          return response;
        },
        (error) => {
          return error;
          //  console.log(error);
          // return false;
        }
      )
    );
  }

  updatelogin(item) {
    this.allServ.updatelogin(item).subscribe(response => {
     
    })
  }

  resetPass(data) {
    // data.username = sessionStorage.getItem('user');
    data.username = this.authMongo.currentUserValue['username'];
    return this.http.post(this.loginUrl + 'auth/password_reset', data).pipe(
      map(
        (response) => {
          return response;
        },
        (error) => {
          return Response;
          //  console.log(error);
          // return false;
        }
      )
    );
  }
}
